<div fxLayout="row" fxLayout.lt-md="column">
  <mat-card fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100" [class.banner-danger]="data?.isHidden">
    <mat-card-content>
      <mat-card-title fxLayout="row" fxLayoutAlign="space-between center">

        <div fxLayout="row" fxLayoutAlign="start end" fxLayoutGap="10px">
          <asset-upload #assetUploadComponent
            [hideButtons]="true"
            (asset)="onAssetLoad($event)">
            <div class="image-container" fxLayout="row" fxLayoutAlign="center center">
              <ng-container *ngIf="!thumbnailData && data?.thumbnailUrl">
                <img [lazyLoad]="data.thumbnailUrl" class="thumbnail">
                
                <div class="overlay-icon" fxLayout="row" fxLayoutAlign="end center">
                  <button mat-icon-button color="accent" matTooltip="Upload new thumbnail" (click)="triggerChildFileUpload()">
                    <mat-icon>add_photo_alternate</mat-icon>
                  </button>
                </div>
              </ng-container>

              <ng-container *ngIf="thumbnailData">
                <img [src]="thumbnailData" class="thumbnail">
                  
                <div class="overlay-icon" fxLayout="row" fxLayoutAlign="space-between center">
                  <button mat-icon-button color="primary" matTooltip="Cancel new thumbnail" (click)="cancelThumbnailUpload()">
                    <mat-icon>close</mat-icon>
                  </button>
                  <button mat-icon-button color="accent" matTooltip="Save new thumbnail" (click)="saveThumbnailUpload()">
                    <mat-icon>done</mat-icon>
                  </button>
                </div>
              </ng-container>
              
              <ng-container *ngIf="!thumbnailData && !data?.thumbnailUrl">
                <img src="/assets/images/add-image-icon.svg" class="thumbnail banner-incomplete">
                
                <div class="overlay-icon" fxLayout="row" fxLayoutAlign="end center">
                  <button mat-icon-button color="accent" matTooltip="Upload new thumbnail" (click)="triggerChildFileUpload()">
                    <mat-icon>add_photo_alternate</mat-icon>
                  </button>
                </div>
              </ng-container>
            </div>
          </asset-upload>
          <div fxLayout="column" fxLayoutAlign="center start">
            <div *ngIf="!home && !tag" fxLayout="row" fxLayoutAlign="start center" class="m-l-10">{{ data?.name }} <mat-icon class="global-icon m-l-10" matTooltip="Global Template">public</mat-icon></div>
            <div *ngIf="home" fxLayout="row" fxLayoutAlign="start center" class="m-l-10">{{ data?.name }} <small class="text-info m-l-10">{{ home }}</small> <mat-icon class="home-icon m-l-10" matTooltip="Home Template">home</mat-icon></div>
            <div *ngIf="!home && tag" fxLayout="row" fxLayoutAlign="start center" class="m-l-10">{{ data?.name }}<small class="text-info m-l-10">{{ tag }}</small> <mat-icon class="tag-icon m-l-10" matTooltip="Tag Template">label</mat-icon></div>
            <div fxLayout="row" fxLayoutAlign="start center"> 
              <button *ngIf="data?.isHidden" mat-icon-button color="primary" matTooltip="Show style template" (click)="hideTemplate(false)">
                <mat-icon>visibility_off</mat-icon>
              </button>
              <button *ngIf="!data?.isHidden" mat-icon-button color="accent" matTooltip="Hide style template" (click)="hideTemplate(true)">
                <mat-icon>visibility</mat-icon>
              </button>
              <button mat-icon-button color="accent" matTooltip="Duplicate style template" (click)="duplicateTemplate()">
                <mat-icon>content_copy</mat-icon>
              </button>
              <button *ngIf="data?.productName === undefined || data?.productName === null || data?.productName === productName.Panorama" 
                mat-icon-button
                [color]="data?.productName === productName.Panorama ? 'accent' : 'basic'"
                [matTooltip]="data?.productName === productName.Panorama ? 'Unset situVIEW only' : 'Set situVIEW only'"
                (click)="setProduct(productName.Panorama)">
                  <mat-icon>image</mat-icon>
              </button>
              <button *ngIf="data?.productName === undefined || data?.productName === null || data?.productName === productName.Facade"
                mat-icon-button
                [color]="data?.productName === productName.Facade ? 'accent' : 'basic'"
                [matTooltip]="data?.productName === productName.Facade ? 'Unset situFACADE only' : 'Set situFACADE only'"
                (click)="setProduct(productName.Facade)">
                  <mat-icon>panorama</mat-icon>
              </button>
            </div>
          </div>
        </div>

        <div>
          <button mat-flat-button color="accent" (click)="enableFacadeBuilder()">{{ showFacadeBuilder ? 'Hide' : 'Show' }} Facade Builder</button>
        </div>

      </mat-card-title>
    </mat-card-content>
  </mat-card>
</div>

<div *ngIf="!showFacadeBuilder" fxLayout="row" fxLayout.lt-md="column">
  <div fxFlex.gt-sm="50" fxFlex.gt-xs="100" fxFlex="100">
    <mat-card class="h-100">
      <mat-card-content class="h-100" id="inRangeContainer" cdkDropList [cdkDropListData]="inTemplate" (cdkDropListDropped)="drop($event)">
        <mat-card [class.banner-incomplete]="!isTemplateModified" [class.banner-warning]="isTemplateModified"
          [ngClass.lt-lg]="{'mat-card-inline-sm': true}">
          <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
            <div fxFlex="60" fxLayoutAlign="start center" fxLayout="row">
              <strong>selected styles</strong>
            </div>
            <div fxFlex="40" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="0px" fxLayoutGap.lt-sm="18px">
              <div fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign.lt-sm="center center" class="date-text">
                <button *ngIf="isTemplateModified"
                  mat-icon-button color="primary"
                  matTooltip="Save Style Template"
                  aria-label="Save Style Template"
                  (click)="saveStyleTemplate()">
                  <mat-icon>done</mat-icon>
                </button>
                <button *ngIf="isTemplateModified"
                  mat-icon-button color="basic"
                  matTooltip="Clear Changes"
                  aria-label="Clear Changes"
                  (click)="clearChanges()">
                  <mat-icon>restart_alt</mat-icon>
                </button>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
        <div *ngFor="let item of inTemplate; let i = index;">
          <style-template-card cdkDrag
            [id]="item?.id"
            [companyId]="selectedCompany?.id"
            [companyName]="getCompanyName(item?.companyId)"
            [companyLogo]="getCompanyLogo(item?.companyId)"
            [name]="getThemeDisplayName(item?.id, item?.name)"
            [thumbnailUrl]="item?.thumbnailUrl"
            [category]="getCategoryName(item.styleCategoryId)"
            [showClear]="true"
            [showCategory]="true"
            [showSwap]="categoryIsSingle(item.styleCategoryId)"
            [selected]="item?.id === selectedInTemplate?.id"
            (onClear)="onClearTemplate($event)"
            (onSwap)="onSwapTemplate($event)">
          </style-template-card>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
  <div fxFlex.gt-sm="50" fxFlex.gt-xs="100" fxFlex="100">
    <mat-card>
      <mat-card-content>
        <ng-container>
          <mat-card class="banner-incomplete" [ngClass.lt-lg]="{'mat-card-inline-sm': true}">
            <mat-card-content fxLayoutAlign="center center" fxLayout="row-reverse" fxLayout.lt-sm="column">
              <div fxFlex="60" fxLayoutAlign="end center" fxLayout="row">
                <strong>available styles</strong>
              </div>
              <div fxFlex="40" fxLayoutAlign="start center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="0px" fxLayoutGap.lt-sm="18px">
                <div fxLayoutAlign="end center" fxLayout="row-reverse" fxLayout.lt-sm="column-reverse" fxLayoutAlign.lt-sm="center center" class="date-text">
                  <ng-container>
                    <button *ngIf="showAllCompanies"
                      mat-icon-button color="basic"
                      matTooltip="Show this company"
                      aria-label="Show this company"
                      (click)="showAllCompanies = false">
                      <mat-icon>filter_alt</mat-icon>
                    </button>
                    <button *ngIf="!showAllCompanies"
                      mat-icon-button color="basic"
                      matTooltip="Show all companies"
                      aria-label="Show all companies"
                      (click)="showAllCompanies = true">
                      <mat-icon>filter_alt_off</mat-icon>
                    </button>
                  </ng-container>
                  <button
                    mat-icon-button color="basic"
                    matTooltip="Refresh Available Styles"
                    aria-label="Refresh Available Styles"
                    (click)="refreshStyleData()">
                    <mat-icon>refresh</mat-icon>
                  </button>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
          <mat-card class="contrast" [ngClass.lt-lg]="{'mat-card-inline-sm': true}">
            <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
              <mat-form-field>
                <input matInput type="text"
                  [formControl]="searchCategoryDataField"
                  (keyup.esc)="$event.target.value=''; doCategoryDataFilter('')"
                  placeholder="Filter styles">
              </mat-form-field>
            </mat-card-content>
          </mat-card>
          <mat-accordion displayMode="default" multi>
            <ng-container *ngFor="let item of filteredCategoryData">
              <custom-expansion-panel *ngIf="(showAllCompanies || item.companyId === selectedCompany?.id || item.companyId === bridgeCompanyId) && item.styles?.length > 0"
                [title]="getCompanyName(item?.companyId) + ' - ' + item?.name"
                [subtitle]="item?.styles?.length"
                [id]="outRangeContainer + item.id"
                [info]="item?.description"
                [forceOpen]="searchCategoryDataField?.value"
                cdkDropList [cdkDropListData]="item.styles" (cdkDropListDropped)="drop($event)" cdkDropListConnectedTo="inRangeContainer">
                <div *ngFor="let styleNode of item.styles">
                  <style-template-card cdkDrag
                    [cdkDragDisabled]="isInTemplate(styleNode?.id)"
                    [id]="styleNode?.id"
                    [companyId]="item?.companyId"
                    [companyName]="getCompanyName(item?.companyId)"
                    [companyLogo]="getCompanyLogo(item?.companyId)"
                    [name]="styleNode?.displayName"
                    [thumbnailUrl]="styleNode?.thumbnailUrl"
                    [category]="item.styleCategoryId"
                    [showSwap]="selectedInTemplate?.styleCategoryId === styleNode?.styleCategoryId"
                    [readonly]="isInTemplate(styleNode?.id)"
                    (onSwap)="onSwapTemplateSelected($event)">
                  </style-template-card>
                </div>
              </custom-expansion-panel>
            </ng-container>
          </mat-accordion>
        </ng-container>
      </mat-card-content>
    </mat-card>
  </div>
</div>

<div *ngIf="showFacadeBuilder" style="height: 900px;">

  <div fxFlex.gt-sm="60" fxFlex.gt-xs="100" fxFlex="100">
    
    <mat-card class="h-100">
      <mat-card-content class="h-100">
        <div class="h-100" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="10px">
          
          <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
                <button mat-flat-button color="accent" [disabled]="facadeBuilderSingleStorey" (click)="switchFacadeBuilderStorey()">Single Storey Building</button>
                <button mat-flat-button color="accent" [disabled]="!facadeBuilderSingleStorey" (click)="switchFacadeBuilderStorey()">Double Storey Building</button>
          </div>

          <div class="image-stack">
            <img
              *ngFor="let entry of facadeSceneryLayers | keyvalue"
              class="layer"
              [src]="entry.value.src"
              [style.zIndex]="entry.key"
              [ngClass]="entry.value.classes"
              (load)="onFacadeSceneryLayerLoadComplete(entry.key)"
            />
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <div fxFlex.gt-sm="40" fxFlex.gt-xs="100" fxFlex="100">
    <mat-card class="h-100" style="overflow: auto;">
      <mat-card-content>
        <div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">

          <div>
            <strong>Selected Scenery Styles</strong>
            <div *ngFor="let item of inTemplate; let i = index;">
              <style-template-card *ngIf="item.facadeSceneryLayerFileNames" cdkDrag
                [id]="item?.id"
                [companyId]="selectedCompany?.id"
                [companyName]="getCompanyName(item?.companyId)"
                [companyLogo]="getCompanyLogo(item?.companyId)"
                [name]="getThemeDisplayName(item?.id, item?.name)"
                [thumbnailUrl]="item?.thumbnailUrl"
                [category]="getCategoryName(item.styleCategoryId)"
                [showClear]="true"
                [showCategory]="true"
                [showThumbnailUpload]="false"
                [selected]="item?.id === selectedInTemplate?.id"
                (onClear)="onClearTemplate($event);buildFacadeLayers();">
              </style-template-card>
            </div>
          </div>
          
          <div>
            <strong>Available Scenery Styles</strong>
            <mat-accordion displayMode="default" multi>
              <ng-container *ngFor="let item of filteredCategoryData">
                <custom-expansion-panel *ngIf="item.styles?.length > 0"
                  [title]="getCompanyName(item?.companyId) + ' - ' + item?.name"
                  [subtitle]="item?.styles?.length"
                  [id]="outRangeContainer + item.id"
                  [info]="item?.description"
                  [forceOpen]="searchCategoryDataField?.value"
                  cdkDropList [cdkDropListData]="item.styles" (cdkDropListDropped)="drop($event)" cdkDropListConnectedTo="inRangeContainer">
                  <div *ngFor="let styleNode of item.styles" (click)="selectSceneryStyle(styleNode)" style="cursor: pointer;">
                    <style-template-card cdkDrag
                      [cdkDragDisabled]="isInTemplate(styleNode?.id)"
                      [id]="styleNode?.id"
                      [companyId]="item?.companyId"
                      [companyName]="getCompanyName(item?.companyId)"
                      [companyLogo]="getCompanyLogo(item?.companyId)"
                      [name]="styleNode?.displayName"
                      [thumbnailUrl]="styleNode?.thumbnailUrl"
                      [category]="item.styleCategoryId"
                      [showThumbnailUpload]="false"
                      [readonly]="isInTemplate(styleNode?.id)">
                    </style-template-card>
                  </div>
                </custom-expansion-panel>
              </ng-container>
            </mat-accordion>
          </div>
          
        </div>

      </mat-card-content>
    </mat-card>
    
  </div>


</div>